// Dados centrais do site — edite aqui para trocar links, vídeos e contatos.
export const SITE = {
  brand: "iGreen Energia Brasil",
  licenciado: "Lucas Marques & Aline Finger",
  grupo: "Grupo Conexão",
  cidade: "Santa Rosa/RS",
  photo: "/grupo-conexao.jpg",
  licenciadoId: "175747",
  whatsappNumber: "55920039023",
  whatsappMessage: "Oi, eu quero cadastrar minha conta de luz e ganhar o Pix de R$ 50",
  whatsappLicenciadoMessage: "Vim pelo site. Quero saber como ser licenciado iGreen.",
  // Link de indicação para cadastro (ID 175747):
  cadastroUrl: "https://expansao.igreenenergy.com.br/?id=175747",
  // Link de indicação para cadastro de licenciado:
  licenciadoUrl: "https://expansao.igreenenergy.com.br/?id=175747",
  // Vídeo do hero (YouTube embed). Troque o ID abaixo para substituir o vídeo:
  heroVideoId: "ZYk43x89eBY",
  mediaVideos: [
    { id: "HvL8uiK83nY", channel: "Fala da iGreen", title: "Band Minas — Reportagem sobre a Conexão Green, da iGreen" },
    { id: "wcvB9jZHeUY", channel: "Jornal da Cultura", title: "Energia solar por assinatura: a nova tendência de consumo" },
    { id: "Zltkrko9u8A", channel: "Canção Nova", title: "Como funciona a energia solar por assinatura" },
  ],
  reclameAquiVideoId: "LqCe4k8TeNs",
  clubVideos: ["KXOt2RNmEqY", "KQkzSDcBoI8", "C0fAH0d_Bug", "Wb7GWAOdhVM", "fZNeMXBpp-0", "_nNIVxRl-5w"],
  appStoreUrl: "https://apps.apple.com/br/app/igreen-club/id6444493340",
  googlePlayUrl: "https://play.google.com/store/apps/details?id=com.embarcadero.iGreenConnect",
};

export const waLink = (message = SITE.whatsappMessage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const IMAGES = {
  heroSolar: "https://images.unsplash.com/photo-1723133371535-1412bc2e412e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  solarField: "https://images.unsplash.com/photo-1508001300512-4763bb1c5583?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  rooftop: "https://images.unsplash.com/photo-1614366502473-e54666693b44?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const MARQUEE_ITEMS = [
  "Desconto na conta de luz", "Economia real", "Sem obra", "Sem investimento",
  "Energia solar", "Clube de benefícios", "Soluções inteligentes", "Mercado livre de energia",
  "Celular 5G", "Internet que acumula", "Seguro auto e moto", "Sustentabilidade",
  "Empreendedorismo", "Atendimento no WhatsApp",
];

export const CLUB_CATEGORIES = [
  "Lanches", "Cinema", "Pet shop", "Farmácia", "Pizzarias", "Joias", "Restaurantes",
  "Moda", "Eletro", "Cafeterias", "Beleza", "Calçados", "Academias", "Viagens", "Mercado",
];

export const TESTIMONIALS = [
  {
    name: "Marcos Silva", city: "Belo Horizonte - MG", savings: "Economia de R$ 340/mês",
    url: "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    quote: "Sem gastar 1 real com placas, minha conta caiu de R$ 980 para R$ 640. Assinatura digital super rápida no WhatsApp!",
  },
  {
    name: "Juliana Santos", city: "Uberlândia - MG", savings: "Economia de R$ 520/mês",
    url: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    quote: "Tenho uma padaria e o custo de energia pesava muito. A iGreen conectou nossa empresa em menos de 5 minutos.",
  },
  {
    name: "Carlos Eduardo", city: "Goiânia - GO", savings: "Economia de R$ 210/mês",
    url: "https://images.unsplash.com/photo-1583123810408-23e7b5d1af9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    quote: "O iGreen Club é sensacional! Além do desconto na luz, ganho cashback em farmácias e supermercados.",
  },
  {
    name: "Renato Oliveira", city: "Salvador - BA", savings: "Economia de R$ 410/mês",
    url: "https://images.unsplash.com/photo-1504199367641-aba8151af406?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    quote: "Achava que precisava fazer obras no telhado. Descobri que é 100% digital e sem fidelidade. Recomendo de olhos fechados!",
  },
];

export const FAQ = [
  { q: "Preciso instalar alguma coisa ou fazer obra?", a: "Não. Na Conexão Green a energia vem de usinas solares parceiras e entra como crédito na sua conta. Nada muda no seu imóvel, no medidor ou na sua distribuidora." },
  { q: "Por que vou receber duas faturas?", a: "Porque a distribuidora continua cobrando a taxa mínima, a iluminação pública e os impostos, e a iGreen cobra a energia com desconto. Somadas, as duas saem mais baratas do que a conta de antes. Eu te mostro esse cálculo antes de você assinar." },
  { q: "Em quanto tempo o desconto começa?", a: "Depois que o cadastro é validado, a distribuidora precisa registrar os créditos da usina. Em geral o primeiro desconto aparece em cerca de 90 dias; não existe prazo único, vale o do seu contrato." },
  { q: "Isso é programa do governo? A iGreen é a distribuidora?", a: "Não e não. A iGreen Energy é uma empresa privada, e eu sou um licenciado autorizado dela. A distribuidora continua a mesma, entregando a energia. Desconfie de quem oferecer isso como programa do governo." },
  { q: "Qual é o desconto?", a: "Até 15%, conforme a distribuidora e a faixa de consumo da sua região. O desconto vale sobre a energia compensada; taxa mínima, iluminação pública e impostos não entram." },
  { q: "Quem pode contratar?", a: "Casas e empresas com conta a partir de cerca de 100 a 150 kWh por mês, nas regiões atendidas. Quem tem tarifa social ou já gera energia solar no imóvel não entra na Conexão Green." },
  { q: "Tem fidelidade? E se eu quiser cancelar?", a: "Na energia por assinatura não há fidelidade no plano padrão. O cancelamento é feito pelo canal de atendimento ao cliente, e as faturas continuam chegando até acabar a energia que já foi enviada para a sua conta, porque é energia que você já usou." },
  { q: "Quem vai me atender?", a: `A gente: Lucas Marques e Aline Finger, do Grupo Conexão em Santa Rosa/RS — Licenciados Autorizados iGreen Energy (ID ${SITE.licenciadoId}). Você fala com a gente pelo WhatsApp do começo ao fim.` },
];

export const UFS = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

export const INTERESTS = [
  "Desconto na conta de luz", "Energia para minha empresa", "Energia solar sem investimento",
  "Comprar placas solares", "Plano de celular", "Seguro de carro ou moto",
  "Eletroposto (iGreen Mob)", "Quero ser licenciado",
];

export const BILL_RANGES = ["Até R$ 150", "R$ 150 a R$ 300", "R$ 300 a R$ 600", "R$ 600 a R$ 1.500", "Acima de R$ 1.500"];

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
